export default __webpack_public_path__ + "static/media/radio-btn-new.ee8cf476.svg";